import { isInIframe } from '@/Utils/iframe-utils';

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

export const shouldRedirectDirectAccess = (): boolean => {
  if (isInIframe()) {
    return false;
  }

  return !LOCAL_HOSTNAMES.has(window.location.hostname);
};

export const redirectDirectAccessToIdentity = (): boolean => {
  const authorityUrl = import.meta.env.VITE_OIDC_AUTHORITY_URL;

  if (!authorityUrl || !shouldRedirectDirectAccess()) {
    return false;
  }

  window.location.replace(authorityUrl);
  return true;
};
